import { render, staticRenderFns } from "./FiltersBox.vue?vue&type=template&id=aca68a30&scoped=true&"
import script from "./FiltersBox.vue?vue&type=script&lang=ts&"
export * from "./FiltersBox.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersBox.vue?vue&type=style&index=0&id=aca68a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca68a30",
  null
  
)

export default component.exports